import type { ExtraKind } from './types'

/**
 * D47 · Entrar antes y salir más tarde tienen un único camino: el flujo de cambios de reserva (bloque 5). E9 no
 * dice qué es cada extra, así que se reconoce por el nombre, como la heurística del clima (D13) y de las
 * instrucciones de entrada (D40). Pedido a backend como `Extra.kind` (docs/backend/extras.md).
 */
const LATE = /salida\s+tard[ií]a|late\s*check[\s-]?out|check[\s-]?out\s+tard[ií]o|uscita\s+posticipata|late\s+check[\s-]?out|d[ée]part\s+tardif/i
const EARLY = /entrada\s+anticipada|llegada\s+anticipada|early\s*check[\s-]?in|check[\s-]?in\s+anticipado|ingresso\s+anticipato|arriv[ée]e\s+anticip[ée]e/i

export function kindOf(name: string): ExtraKind {
  if (LATE.test(name)) return 'late_checkout'
  if (EARLY.test(name)) return 'early_checkin'
  return 'extra'
}
